var chunkMapping = {
	"0": [
		4922
	],
	"76": [
		5040
	],
	"151": [
		5115
	],
	"152": [
		5116
	],
	"155": [
		5119
	],
	"156": [
		5120
	],
	"157": [
		5121
	],
	"158": [
		5122
	],
	"159": [
		5123
	],
	"160": [
		5124
	],
	"161": [
		5125
	],
	"162": [
		5126
	],
	"163": [
		5127
	],
	"164": [
		5128
	],
	"165": [
		5129
	],
	"166": [
		5130
	],
	"167": [
		5131
	],
	"168": [
		5132
	],
	"169": [
		5133
	],
	"170": [
		5134
	],
	"171": [
		5135
	]
};
var idToExternalAndNameMapping = {
	"4922": [
		"default",
		"./Containers",
		3795
	],
	"5040": [
		"default",
		"./OrderlessInvoices",
		3795
	],
	"5115": [
		"default",
		"./AsyncEventTracker",
		3795
	],
	"5116": [
		"default",
		"./HostWrapper",
		3795
	],
	"5119": [
		"default",
		"./CheckoutV3",
		3795
	],
	"5120": [
		"default",
		"./CheckoutConfirmation",
		3795
	],
	"5121": [
		"default",
		"./ContactCreditCards",
		3795
	],
	"5122": [
		"default",
		"./AuditDialog",
		3795
	],
	"5123": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3795
	],
	"5124": [
		"default",
		"./InvoiceDialog",
		3795
	],
	"5125": [
		"default",
		"./PaymentDueModal",
		3795
	],
	"5126": [
		"default",
		"./PaymentModal",
		3795
	],
	"5127": [
		"default",
		"./PaymentHistory",
		3795
	],
	"5128": [
		"default",
		"./PaymentConfigurations",
		3795
	],
	"5129": [
		"default",
		"./PaymentPreferences",
		3795
	],
	"5130": [
		"default",
		"./ManagePaymentProcessing",
		3795
	],
	"5131": [
		"default",
		"./MobilePaymentsWrapper",
		3795
	],
	"5132": [
		"default",
		"./Challenge",
		3795
	],
	"5133": [
		"default",
		"./ManagePaymentMethods",
		3795
	],
	"5134": [
		"default",
		"./LightspeedReports",
		3795
	],
	"5135": [
		"default",
		"./ShippingPromotionsListContainer",
		3795
	]
};
var idToRemoteMap = {
	"4922": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5040": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5115": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5116": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5119": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5120": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5121": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5122": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5123": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5124": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5125": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5126": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5127": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5128": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5129": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5130": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5131": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5132": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5133": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5134": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5135": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}